import { BioSampleCodeFormatterUtil } from '@csp/csp-common-hbs';
import { ZonedDateTimeDisplayMapper } from '@csp/csp-common-date-util';
import { BioSampleContainerDisplay } from '../model/BioSampleContainerDisplay';
import { BioSampleContainerDisplayLabels } from '../model/BioSampleContainerDisplayLabels';
import { BioSampleContainerItem } from '../model/BioSampleContainerItem';
import { BioSampleContainerItemIn } from '../model/BioSampleContainerItemIn';
import { BioSampleContentService } from '../service/BioSampleContentService';
import { BioSampleItemMapper } from './BioSampleItemMapper';

const toBioSampleContainerDisplayLabels = (): BioSampleContainerDisplayLabels => {
  const kitTexts = BioSampleContentService.getKitDetailsTexts();
  const { sampleStatusLabel, sampleStatusDateTimeLabel, processComplianceStatusLabel } =
    BioSampleItemMapper.toBioSampleDisplayLabels();

  return {
    sampleStatusLabel,
    sampleStatusDateTimeLabel,
    processComplianceStatusLabel,
    sampleContainerCodeLabel: kitTexts.drawer.header.container.text,
    containerDescriptionLabel: kitTexts.drawer.header.containerDescription.text,
    containerPatientVisitLabel: kitTexts.drawer.header.containerPatientVisit.text,
  };
};

const toBioSampleContainerDisplay = ({
  container,
  bioSampleItem,
  formats,
}: BioSampleContainerItemIn): BioSampleContainerDisplay => ({
  sampleContainerCode: container.sampleContainerCode ?? '',
  kitCode: container.kitCode,
  containerNumber: BioSampleCodeFormatterUtil.toBioSampleDisplayContainerNumber(container.containerNumber, formats),
  containerDescription: container.containerDescription,
  sampleStatus: bioSampleItem?.display.sampleStatus ?? '',
  sampleStatusDateTime:
    bioSampleItem?.display.sampleStatusDateTime ?? ZonedDateTimeDisplayMapper.toDisplayInTimestampTimezone(undefined),
  visitName: bioSampleItem?.display.visitName ?? '',
  ecode: bioSampleItem?.display.ecode ?? '',
  ...toBioSampleContainerDisplayLabels(),
});

const toBioSampleContainerItem = ({
  container,
  bioSampleItem,
  formats,
}: BioSampleContainerItemIn): BioSampleContainerItem => ({
  ...container,
  display: toBioSampleContainerDisplay({ container, bioSampleItem, formats }),
  bioSampleItem,
});

export const BioSampleContainerItemMapper = {
  toBioSampleContainerItem,
  toBioSampleContainerDisplayLabels,
};
